// extracted by mini-css-extract-plugin
export default {"red":"components-colored-text_red"};